<template>
  <v-dialog v-model="isOpen" persistent width="500" class>
    <v-card class>
      <v-card-title>
        <span class="headline">{{$t('titles.newProject')}}</span>
      </v-card-title>
      <v-form
        ref="form"
        v-model="valid"
      >
      <v-container>
      <v-layout justify-space-around>
        <v-flex xs4>
              <h2 class="subheader" style="font-size: 18px">{{$t('texts.createNewProj')}} <br> {{projectOrSubProject}}</h2>
              <v-text-field
              :rules="newName"
                name="name"
                :label="$t('labels.projectName')"
                v-model="name"
              ></v-text-field>
            <!-- </v-card> -->
        </v-flex>
        <v-flex xs4>
          
          <h2
            class="subheader"
            style="font-size: 18px"
          >{{$t('texts.addToParent')}}</h2>
          <v-select
            :items="parentProjNames"
            v-model="selectedProject"
            :label="$t('labels.parentProj')"
            color="primary"
            solo
            class="combobox-parent"
          ></v-select>
        </v-flex>
      </v-layout>
      </v-container>
      </v-form>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="toggle">{{$t('buttons.close')}}</v-btn>
        <v-btn color="primary" flat @click="saveAndGo()">{{$t('buttons.create')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { router } from "@/_helpers";

export default {
  data() {
    return {
      name: "",
      parentsProj: [],
      parentProjNames: [],
      selectedProject: "",
      valid: true,
      projectOrSubProject: this.$t('texts.proj'),
      childExist: true,
      parentExist: true
    };
  },
  watch: {
    // les watch sont utilisés pour la validation
    // =================
    selectedProject() {
      if (this.selectedProject == "no parent project") {
        setTimeout(() => {
          this.selectedProject = '';
        }, 1);
        this.projectOrSubProject = this.$t('texts.proj');
      } else if (this.selectedProject != "") {
        this.projectOrSubProject = this.$t('texts.subProj');
      }
      this.validProject();
    },
    name() {
      this.validProject();
    }
  },
  computed: {
    newName(){
      return [
        this.childExist || this.$t('errors.childProjExist'),
        this.parentExist || this.$t('errors.parentProjExist'),
        !!this.name || this.$t('errors.nameProjRequired'),
      ];
    },

    isOpen() {
      let open = this.$store.getters["dialogModal/isOpenNewProj"];
      if (open) this.fetchData();
      return open;
    }
  },

  methods: {
    // Récupération des projets (quand openNewProj du store == true)
    // =================
    async fetchData() {
      await this.$store.dispatch("project/getProjects")
        .then((projects) => this.parentsProj = this.projParents(projects));
      this.parentProjNames = this.projNames(this.parentsProj);
      this.parentProjNames.unshift("no parent project");
    },

    pathCurrent() {
      let path = this.$route.path.split("/");
      return path[2];
    },
    toggle() {
      this.$store.dispatch("dialogModal/toggle");
      setTimeout(() => {
        this.$refs.form.reset();
      }, 500);
    },
    getProjectSelected(project_selected) {
      let newProject = null;
      this.parentsProj.forEach(parent => {
        if (parent.name == project_selected) newProject = parent;
      });
      return newProject;
    },
    async createdProject(project) {
        let newProject = await this.$store.dispatch("project/createProject", project);
        return newProject;
    },
    initProject() {
      let project_selected = this.getProjectSelected(this.selectedProject);
      let uuid = project_selected ? project_selected.uuid : "";
      return {
        parent: uuid,
        name: this.name
      };
    },

    /**
     * validProject() Regarde si le nom du projet existe déjà. Si un parent est sélectionné, regarde si le nom du projet enfant existe déjà.
     * childExist et parentExist sont update et sont utilisés pour la la validation du form (:rules="newName").
     * validProject est déclanchée via des watchers name, selectedProject. validProject va lui même déclencer la validation du formulaire
     */
    validProject() {
      let projects = this.$store.getters["project/getProjects"];
      if (!projects)
        return true
      let parents = projects.filter((folder) => folder.parent === null);
      if (this.selectedProject && this.selectedProject != 'no parent project') {  // IL faut vérifier les enfants qui ont comme parent le selected + si le name existe dedans
        let selectedParent = parents.filter((folder) => folder.name == this.selectedProject)[0];
        // let childrens = projects.filter((folder) => folder.parent !== null);
        let duplicatedChild = projects.filter((child) => (
          selectedParent.uuid == child.parent && child.name == this.name)
          );
        // let duplicatedChild = selectedChilds.filter((child) => child.name == this.name);
        if (duplicatedChild.length) {
          this.childExist = false;
          return false;
        } else {
          this.childExist = true;
          this.parentExist = true;
        }
      } else { // Il faut vérifier dans les parents si le name existe
        let duplicatedParent = parents.filter(parent => parent.name == this.name);
        if (duplicatedParent.length) {
          this.parentExist = false;
          return false;
        } else {
          this.parentExist = true
          this.childExist = true;
        }
      }
        this.$refs.form.validate();
          if (!this.valid) return false;
      return true;
    },
    async saveAndGo() {
      this.$refs.form.validate();
      if (!this.valid) return;
      const project = this.initProject();
      let newProject = await this.createdProject(project);
      this.$router.push("/projects/" + newProject.uuid);
      this.$store.commit("project/setLatestProj", newProject);
      this.toggle();
    }
  }
};
</script>

<style lang="sass" scoped>
.combobox-parent 
  padding-top: 5px
</style>
